var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { collectSliderImagesFromDom } from './collectImages';
import { createInstagramZip, downloadBlob } from './createZip';
import { renderCover } from './renderCover';
import { INSTAGRAM_HEIGHT, INSTAGRAM_WIDTH, MAX_SLIDER_SELECTION, } from './types';
var OVERLAY_ID = 'instagram-post-export-overlay';
function readExportData() {
    var script = document.getElementById('instagram-post-export-data');
    if (!(script === null || script === void 0 ? void 0 : script.textContent))
        return null;
    try {
        return JSON.parse(script.textContent);
    }
    catch (_a) {
        return null;
    }
}
function getSliderImages(data) {
    if (data.sliderImages.length > 0) {
        return data.sliderImages;
    }
    return collectSliderImagesFromDom();
}
function createOverlayShell() {
    var existing = document.getElementById(OVERLAY_ID);
    if (existing) {
        existing.remove();
    }
    var overlay = document.createElement('div');
    overlay.id = OVERLAY_ID;
    overlay.className =
        'fixed inset-0 z-[100] flex items-end sm:items-center justify-center bg-black/70 p-0 sm:p-6';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'instagram-export-title');
    overlay.innerHTML = "\n    <div class=\"relative flex h-[92vh] sm:h-auto sm:max-h-[90vh] w-full sm:max-w-4xl flex-col overflow-hidden rounded-t-2xl sm:rounded-2xl bg-white shadow-2xl\">\n      <div class=\"flex items-start justify-between gap-4 border-b border-slate-200 px-6 py-5\">\n        <div>\n          <h2 id=\"instagram-export-title\" class=\"text-xl font-bold text-slate-900\">Instagram Post erstellen</h2>\n          <p class=\"mt-1 text-sm text-slate-600\">W\u00E4hle bis zu ".concat(MAX_SLIDER_SELECTION, " Bilder aus den Image Slidern (").concat(INSTAGRAM_WIDTH, " \u00D7 ").concat(INSTAGRAM_HEIGHT, " px).</p>\n        </div>\n        <button type=\"button\" data-instagram-export-close class=\"rounded-full p-2 text-slate-500 transition hover:bg-slate-100 hover:text-slate-900\" aria-label=\"Schlie\u00DFen\">\n          <svg class=\"h-5 w-5\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" aria-hidden=\"true\">\n            <path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M6 18L18 6M6 6l12 12\" />\n          </svg>\n        </button>\n      </div>\n\n      <div data-instagram-export-status class=\"hidden border-b border-amber-200 bg-amber-50 px-6 py-3 text-sm text-amber-900\"></div>\n\n      <div data-instagram-export-cover class=\"border-b border-slate-200 px-6 py-5\">\n        <p class=\"mb-3 text-sm font-semibold text-slate-800\">Cover-Vorschau</p>\n        <div class=\"relative mx-auto aspect-[4/5] w-full max-w-[220px] overflow-hidden rounded-xl border border-slate-200 bg-slate-100 shadow-sm\">\n          <img\n            data-instagram-export-cover-img\n            alt=\"Cover-Vorschau\"\n            class=\"hidden h-full w-full object-cover\"\n          />\n          <div\n            data-instagram-export-cover-loading\n            class=\"absolute inset-0 flex items-center justify-center text-sm text-slate-500\"\n          >\n            Wird geladen\u2026\n          </div>\n        </div>\n      </div>\n\n      <div data-instagram-export-grid class=\"flex-1 overflow-y-auto px-6 py-5\">\n        <div class=\"grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4\"></div>\n      </div>\n\n      <div class=\"border-t border-slate-200 bg-slate-50 px-6 py-4\">\n        <div class=\"flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between\">\n          <p data-instagram-export-counter class=\"text-sm text-slate-600\">0 / ").concat(MAX_SLIDER_SELECTION, " ausgew\u00E4hlt</p>\n          <button\n            type=\"button\"\n            data-instagram-export-create\n            disabled\n            class=\"inline-flex items-center justify-center rounded-full bg-primary px-6 py-3 text-sm font-semibold text-white transition hover:bg-primary/90 disabled:cursor-not-allowed disabled:opacity-50\"\n          >\n            Erstellen\n          </button>\n        </div>\n      </div>\n    </div>\n  ");
    document.body.appendChild(overlay);
    document.body.classList.add('overflow-hidden');
    return overlay;
}
function renderGrid(overlay, images, selectedKeys) {
    var grid = overlay.querySelector('[data-instagram-export-grid] > div');
    var status = overlay.querySelector('[data-instagram-export-status]');
    if (!grid || !status)
        return;
    if (images.length === 0) {
        status.textContent =
            'In diesem Beitrag wurden keine Bilder in Image-Slider-Blöcken gefunden.';
        status.classList.remove('hidden');
        grid.innerHTML = '';
        return;
    }
    status.classList.add('hidden');
    grid.innerHTML = images
        .map(function (image, index) {
        var key = imageKey(image, index);
        var selected = selectedKeys.has(key);
        return "\n        <button\n          type=\"button\"\n          data-instagram-export-image=\"".concat(key, "\"\n          aria-pressed=\"").concat(selected ? 'true' : 'false', "\"\n          class=\"group relative aspect-[4/5] overflow-hidden rounded-xl border-2 transition ").concat(selected
            ? 'border-primary ring-2 ring-primary/30'
            : 'border-slate-200 hover:border-slate-300', "\"\n        >\n          <img src=\"").concat(escapeAttr(image.url), "\" alt=\"").concat(escapeAttr(image.alt || "Slider Bild ".concat(index + 1)), "\" class=\"h-full w-full object-cover\" loading=\"lazy\" />\n          <span class=\"absolute inset-0 bg-black/0 transition group-hover:bg-black/10 ").concat(selected ? 'bg-black/20' : '', "\"></span>\n          <span data-instagram-export-check class=\"absolute right-2 top-2 flex h-7 w-7 items-center justify-center rounded-full text-xs font-bold ").concat(selected ? 'bg-primary text-white' : 'bg-white/90 text-slate-700', "\">\n            ").concat(selected ? '✓' : '', "\n          </span>\n        </button>\n      ");
    })
        .join('');
}
function imageKey(image, index) {
    if (image.id > 0) {
        return "id:".concat(image.id);
    }
    return "url:".concat(image.url, ":").concat(index);
}
function escapeAttr(value) {
    return value
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}
function updateCounter(overlay, count) {
    var counter = overlay.querySelector('[data-instagram-export-counter]');
    var createButton = overlay.querySelector('[data-instagram-export-create]');
    if (counter) {
        counter.textContent = "".concat(count, " / ").concat(MAX_SLIDER_SELECTION, " ausgew\u00E4hlt");
    }
    if (createButton) {
        createButton.disabled = count < 1;
        createButton.textContent = count > 0 ? 'Erstellen' : 'Erstellen';
    }
}
function closeOverlay(overlay) {
    var coverImg = overlay.querySelector('[data-instagram-export-cover-img]');
    if (coverImg === null || coverImg === void 0 ? void 0 : coverImg.src.startsWith('blob:')) {
        URL.revokeObjectURL(coverImg.src);
    }
    overlay.remove();
    document.body.classList.remove('overflow-hidden');
}
function loadCoverPreview(overlay, data) {
    return __awaiter(this, void 0, Promise, function () {
        var coverImg, loading, blob, url, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    coverImg = overlay.querySelector('[data-instagram-export-cover-img]');
                    loading = overlay.querySelector('[data-instagram-export-cover-loading]');
                    if (!coverImg || !loading)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, renderCover(data)];
                case 2:
                    blob = _a.sent();
                    url = URL.createObjectURL(blob);
                    coverImg.src = url;
                    coverImg.classList.remove('hidden');
                    loading.classList.add('hidden');
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    loading.textContent =
                        error_1 instanceof Error
                            ? error_1.message
                            : 'Cover-Vorschau konnte nicht geladen werden.';
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function openInstagramExportOverlay(data) {
    var _this = this;
    var images = getSliderImages(data);
    var selectedKeys = new Set();
    var overlay = createOverlayShell();
    renderGrid(overlay, images, selectedKeys);
    updateCounter(overlay, 0);
    void loadCoverPreview(overlay, data);
    var closeButton = overlay.querySelector('[data-instagram-export-close]');
    var createButton = overlay.querySelector('[data-instagram-export-create]');
    var grid = overlay.querySelector('[data-instagram-export-grid]');
    var onKeyDown = function (event) {
        if (event.key === 'Escape') {
            closeOverlay(overlay);
            document.removeEventListener('keydown', onKeyDown);
        }
    };
    document.addEventListener('keydown', onKeyDown);
    closeButton === null || closeButton === void 0 ? void 0 : closeButton.addEventListener('click', function () {
        closeOverlay(overlay);
        document.removeEventListener('keydown', onKeyDown);
    });
    overlay.addEventListener('click', function (event) {
        if (event.target === overlay) {
            closeOverlay(overlay);
            document.removeEventListener('keydown', onKeyDown);
        }
    });
    grid === null || grid === void 0 ? void 0 : grid.addEventListener('click', function (event) {
        var target = event.target.closest('[data-instagram-export-image]');
        if (!target)
            return;
        var key = target.getAttribute('data-instagram-export-image');
        if (!key)
            return;
        if (selectedKeys.has(key)) {
            selectedKeys.delete(key);
        }
        else if (selectedKeys.size >= MAX_SLIDER_SELECTION) {
            return;
        }
        else {
            selectedKeys.add(key);
        }
        renderGrid(overlay, images, selectedKeys);
        updateCounter(overlay, selectedKeys.size);
    });
    createButton === null || createButton === void 0 ? void 0 : createButton.addEventListener('click', function () { return __awaiter(_this, void 0, void 0, function () {
        var selectedImages, zipBlob, error_2, status;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!createButton || selectedKeys.size < 1)
                        return [2 /*return*/];
                    selectedImages = images.filter(function (image, index) {
                        return selectedKeys.has(imageKey(image, index));
                    });
                    createButton.disabled = true;
                    createButton.textContent = 'Wird erstellt…';
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, createInstagramZip(data, selectedImages)];
                case 2:
                    zipBlob = _a.sent();
                    downloadBlob(zipBlob, "".concat(data.slug || 'instagram-post', ".zip"));
                    closeOverlay(overlay);
                    document.removeEventListener('keydown', onKeyDown);
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    status = overlay.querySelector('[data-instagram-export-status]');
                    if (status) {
                        status.textContent =
                            error_2 instanceof Error
                                ? error_2.message
                                : 'Beim Erstellen des ZIP ist ein Fehler aufgetreten.';
                        status.classList.remove('hidden');
                        status.classList.remove('bg-amber-50', 'border-amber-200', 'text-amber-900');
                        status.classList.add('bg-red-50', 'border-red-200', 'text-red-900');
                    }
                    createButton.disabled = false;
                    createButton.textContent = 'Erstellen';
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); });
}
export function initInstagramPostExport() {
    var data = readExportData();
    if (!data)
        return;
    var trigger = document.querySelector('[data-instagram-export-trigger]');
    if (!trigger)
        return;
    trigger.addEventListener('click', function () {
        openInstagramExportOverlay(data);
    });
}
